import ltOrderSummaryZeroState from 'html/shopping-cart/lt-order-summary-zero-state.html';
import App from 'app/app.js';
import 'app/directive/LtOrderSummaryZeroStateCtrl.js';

function LtOrderSummaryZeroStateDirective() {
  return {
    restrict: 'E',
    scope: {
      subjectFirstName: '=',
      addNewStudent: '&'
    },
    template: ltOrderSummaryZeroState,
    controller: 'LtOrderSummaryZeroStateCtrl',
    controllerAs: 'orderSummaryZeroStateCtrl'
  };
}

App.directive('ltOrderSummaryZeroState', [LtOrderSummaryZeroStateDirective]);
